import { render, staticRenderFns } from "./testStatusLegend.vue?vue&type=template&id=72be63ca&scoped=true"
import script from "./testStatusLegend.vue?vue&type=script&lang=js"
export * from "./testStatusLegend.vue?vue&type=script&lang=js"
import style0 from "./testStatusLegend.vue?vue&type=style&index=0&id=72be63ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72be63ca",
  null
  
)

export default component.exports